export const THEME_STORAGE_KEY = 'darshboard-theme';

export const DEFAULT_THEME_ID = 'default';

export const themeMap = {
  default: {
    id: 'default',
    label: 'Default',
    description: 'The original ember-toned Darshboard look.',
    metaColor: '#0f0f0f',
    preview: {
      primary: '#e84b2f',
      surface: '#141414',
      accent: '#ffffff',
    },
    tokens: {
      palette1: '208, 50, 22',
      palette2: '232, 75, 47',
      palette3: '230, 230, 230',
      palette4: '25, 25, 25',
      palette5: '15, 15, 15',
      palette6: '255, 255, 255',
      palette7: '204, 204, 204',
      palette8: '30, 30, 30',
      palette9: '20, 20, 20',
      palette10: '38, 38, 38',
      palette11: '242, 242, 242',
      palette12: '153, 153, 153',
      palette13: '45, 45, 45',
      palette14: '56, 56, 56',
      palette15: '36, 36, 36',
      palette16: '10, 10, 10',
      primaryDeep: '185, 44, 19',
      primaryGlow: '237, 115, 93',
      primaryGlowStrong: '235, 95, 70',
      success: '109, 211, 61',
    },
  },
  ocean: {
    id: 'ocean',
    label: 'Ocean',
    description: 'Cool electric blues over deep navy surfaces.',
    metaColor: '#08101a',
    preview: {
      primary: '#4aa8ff',
      surface: '#101a28',
      accent: '#dff1ff',
    },
    tokens: {
      palette1: '28, 111, 182',
      palette2: '74, 168, 255',
      palette3: '223, 241, 255',
      palette4: '18, 30, 44',
      palette5: '8, 16, 26',
      palette6: '245, 251, 255',
      palette7: '195, 214, 231',
      palette8: '30, 47, 66',
      palette9: '16, 26, 40',
      palette10: '28, 43, 59',
      palette11: '241, 248, 255',
      palette12: '140, 171, 198',
      palette13: '39, 58, 79',
      palette14: '53, 80, 104',
      palette15: '26, 39, 53',
      palette16: '6, 12, 20',
      primaryDeep: '18, 88, 148',
      primaryGlow: '122, 194, 255',
      primaryGlowStrong: '94, 181, 255',
      success: '62, 214, 164',
    },
  },
  violet: {
    id: 'violet',
    label: 'Violet',
    description: 'Rich plum surfaces with luminous violet accents.',
    metaColor: '#120d18',
    preview: {
      primary: '#ab76ff',
      surface: '#1d1626',
      accent: '#f2eaff',
    },
    tokens: {
      palette1: '132, 75, 224',
      palette2: '171, 118, 255',
      palette3: '242, 234, 255',
      palette4: '29, 22, 38',
      palette5: '18, 13, 24',
      palette6: '252, 248, 255',
      palette7: '214, 202, 228',
      palette8: '41, 31, 54',
      palette9: '24, 19, 33',
      palette10: '36, 28, 47',
      palette11: '247, 240, 255',
      palette12: '167, 150, 192',
      palette13: '50, 38, 66',
      palette14: '69, 53, 90',
      palette15: '33, 25, 43',
      palette16: '12, 8, 18',
      primaryDeep: '112, 57, 195',
      primaryGlow: '205, 171, 255',
      primaryGlowStrong: '190, 147, 255',
      success: '110, 214, 153',
    },
  },
  forest: {
    id: 'forest',
    label: 'Forest',
    description: 'Botanical greens with darker pine-tinted panels.',
    metaColor: '#0d1512',
    preview: {
      primary: '#47c98b',
      surface: '#17231d',
      accent: '#e6fff1',
    },
    tokens: {
      palette1: '29, 147, 94',
      palette2: '71, 201, 139',
      palette3: '230, 255, 241',
      palette4: '23, 35, 29',
      palette5: '13, 21, 18',
      palette6: '248, 255, 251',
      palette7: '193, 219, 203',
      palette8: '33, 49, 41',
      palette9: '18, 28, 23',
      palette10: '30, 43, 36',
      palette11: '239, 250, 244',
      palette12: '138, 169, 151',
      palette13: '41, 58, 49',
      palette14: '57, 81, 68',
      palette15: '28, 40, 33',
      palette16: '9, 14, 12',
      primaryDeep: '22, 117, 74',
      primaryGlow: '133, 228, 179',
      primaryGlowStrong: '105, 216, 160',
      success: '133, 226, 88',
    },
  },
  amber: {
    id: 'amber',
    label: 'Amber',
    description: 'Warm amber highlights with softened charcoal tones.',
    metaColor: '#17110b',
    preview: {
      primary: '#f2a63a',
      surface: '#241a12',
      accent: '#fff4dd',
    },
    tokens: {
      palette1: '204, 127, 18',
      palette2: '242, 166, 58',
      palette3: '255, 244, 221',
      palette4: '36, 26, 18',
      palette5: '23, 17, 11',
      palette6: '255, 250, 240',
      palette7: '223, 205, 177',
      palette8: '49, 37, 26',
      palette9: '29, 22, 15',
      palette10: '42, 31, 21',
      palette11: '255, 247, 229',
      palette12: '180, 152, 112',
      palette13: '59, 44, 30',
      palette14: '83, 62, 41',
      palette15: '38, 28, 19',
      palette16: '12, 9, 6',
      primaryDeep: '171, 104, 12',
      primaryGlow: '255, 204, 129',
      primaryGlowStrong: '248, 184, 88',
      success: '128, 214, 105',
    },
  },
  crimson: {
    id: 'crimson',
    label: 'Crimson',
    description: 'High-contrast red accents with cool shadowed neutrals.',
    metaColor: '#170d11',
    preview: {
      primary: '#f05d6c',
      surface: '#24161a',
      accent: '#ffeef1',
    },
    tokens: {
      palette1: '199, 48, 73',
      palette2: '240, 93, 108',
      palette3: '255, 238, 241',
      palette4: '36, 22, 26',
      palette5: '23, 13, 17',
      palette6: '255, 247, 248',
      palette7: '224, 198, 202',
      palette8: '50, 31, 36',
      palette9: '29, 18, 21',
      palette10: '43, 27, 31',
      palette11: '250, 239, 241',
      palette12: '180, 145, 152',
      palette13: '60, 38, 44',
      palette14: '84, 55, 62',
      palette15: '39, 24, 28',
      palette16: '12, 7, 9',
      primaryDeep: '164, 33, 56',
      primaryGlow: '255, 152, 164',
      primaryGlowStrong: '249, 122, 136',
      success: '121, 221, 142',
    },
  },
  mono: {
    id: 'mono',
    label: 'Monochrome',
    description: 'Neutral graphite with bright monochrome contrast.',
    metaColor: '#0f0f0f',
    preview: {
      primary: '#cfcfcf',
      surface: '#171717',
      accent: '#ffffff',
    },
    tokens: {
      palette1: '163, 163, 163',
      palette2: '207, 207, 207',
      palette3: '245, 245, 245',
      palette4: '27, 27, 27',
      palette5: '15, 15, 15',
      palette6: '255, 255, 255',
      palette7: '211, 211, 211',
      palette8: '35, 35, 35',
      palette9: '22, 22, 22',
      palette10: '41, 41, 41',
      palette11: '247, 247, 247',
      palette12: '162, 162, 162',
      palette13: '48, 48, 48',
      palette14: '66, 66, 66',
      palette15: '33, 33, 33',
      palette16: '9, 9, 9',
      primaryDeep: '120, 120, 120',
      primaryGlow: '233, 233, 233',
      primaryGlowStrong: '219, 219, 219',
      success: '175, 175, 175',
    },
  },
};

export const themeOptions = Object.values(themeMap);

export const isValidThemeId = (themeId) => Boolean(themeMap[themeId]);
